/* Vibralivo: Scroll-Einblenden fuer Abschnitte und Karten */
(function () {
  "use strict";
  if (!("IntersectionObserver" in window)) return;
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  var selectors = [".section-head", ".product-card", ".valueprop", ".collection-card", ".faq__item", ".newsletter", ".testi", ".pinfo", ".product__payments"];
  var els = Array.prototype.slice.call(document.querySelectorAll(selectors.join(",")));
  var vh = window.innerHeight || document.documentElement.clientHeight;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      io.unobserve(el);
      el.classList.add("is-visible");
      var cleaned = false;
      var cleanup = function (e) {
        if (cleaned || (e && e.target !== el)) return;
        cleaned = true;
        el.classList.remove("reveal", "is-visible");
        el.style.transitionDelay = "";
        el.removeEventListener("transitionend", cleanup);
      };
      el.addEventListener("transitionend", cleanup);
      setTimeout(cleanup, 1800);
    });
  }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });

  els.forEach(function (el) {
    if (el.getBoundingClientRect().top < vh) return; /* sichtbare Elemente nicht verstecken */
    var index = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
    el.style.transitionDelay = Math.min(index, 6) * 80 + "ms";
    el.classList.add("reveal");
    io.observe(el);
  });
})();
